import get from 'lodash/get';
import debounce from 'lodash/debounce';
import { useEffect, useState } from 'react';

/** return whatever you need */
type ReturnProps = { innerWidth: number; innerHeight: number; screenWidth: number };

/**
 * return some values on window resize event
 * @deprecated
 * use `const sizes = useSelector(commonSelector);`
 */
export const useOnResize = (ms = 250, leading = true): ReturnProps => {
  const [sizes, setSizes] = useState<ReturnProps>({ innerWidth: 0, innerHeight: 0, screenWidth: 0 });

  useEffect(() => {
    const onResize = () => {
      setSizes({
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight,
        screenWidth: get(document.querySelector('body'), 'clientWidth', 0),
      });
    };

    const cachedOnResize = ms > 0 ? debounce(onResize, ms) : onResize;

    window.addEventListener('resize', cachedOnResize);

    if (leading) {
      onResize();
    }

    return () => {
      window.removeEventListener('resize', cachedOnResize);
    };
  }, [ms, leading]);

  return sizes;
};
